import artifact from '$houdini/artifacts/Parts_SetUserSetting'
import { MutationStore } from '../runtime/stores/mutation'

export class Parts_SetUserSettingStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
